import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { SrOnly } from '../Helper/SrOnly/SrOnly';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function TextPlaceholder(props) {
  const {
    __
  } = useTranslator();
  const {
    placeholder = '\u2014',
    label = __('No value')
  } = props;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      "aria-hidden": true,
      title: label,
      children: placeholder
    }), /*#__PURE__*/_jsx(SrOnly, {
      children: label
    })]
  });
}
export default TextPlaceholder;